export default function formatDate(value) {
    const date = new Date(value);

    const now = new Date(); // Get current date and time

    // Check if the date is today
    const isToday = date.toDateString() === now.toDateString();

    // Format hours and minutes
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // If today, format as "Today, 19:00"
    if (isToday) {
        return `Today, ${hours}:${minutes}`;
    }

    // Otherwise, format as "18 Oct 2024, 19:00"
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    return `${day} ${month} ${year}, ${hours}:${minutes}`;
}